import axios from 'axios'

const {
    VUE_APP_BASE_URL,
    VUE_APP_BASE_URL_IE,
    VUE_APP_SPECIALOFFER_CACHED_DATA,
    VUE_APP_API_SERVER,
    VUE_APP_API_MOST_POPULAR,
    VUE_APP_HOLIDAYINSPIRATION,
    VUE_APP_OFFERTYPES
} = process.env

const referer = window.siteVar.referer

const fetchOffers = () => {
    return axios
        .get(`${VUE_APP_SPECIALOFFER_CACHED_DATA}${referer}.json`)
        .then(res => {
            return res.data
        })
        .catch((error) => {
            return error
        })
}


const fetchHolidayInspiration = async (referer) => {
    const _url = `${referer === 'IE' ? VUE_APP_BASE_URL_IE : VUE_APP_BASE_URL}${VUE_APP_HOLIDAYINSPIRATION}/jsonHolidayStylesInspirations?&systemcolumns=2&count=99&category=${referer}`
    return axios
        .get(_url)
        .then(res => {
            return res.data
        }).catch((error) => {
            return error
        })
}

const updateMostPopular = data => {
    return axios
        .post(`${VUE_APP_API_SERVER}${VUE_APP_API_MOST_POPULAR}`,
            data
        )
        .then((resp) => {
            return resp.data
        })
        .catch((error) => {
            return error
        })
}

const getOfferTypes = async (referer, key) => {
    let _url = `${referer === 'IE' ? VUE_APP_BASE_URL_IE : VUE_APP_BASE_URL}${VUE_APP_OFFERTYPES}/jsonOffers?&systemcolumns=2&count=99&category=${referer}${key}`;
    
    return await axios
        .get(_url)
        .then(res => {
            return res.data
        })
        .catch(error => {
            console.log(`[getOfferTypes] ${error.res.data.error} `)
            return [];
         })
}

export {
    fetchOffers,
    fetchHolidayInspiration,
    updateMostPopular,
    getOfferTypes
}
